module.exports = __webpack_public_path__ + "static/media/menu-close.cf22f6f3.svg";